import { Button } from '@material-ui/core';
import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { ReportLookerData } from 'services/dataService';
import { toast } from 'react-toastify';
import MaterialTable from 'material-table';
import { enrollmentsLooker } from './helper';


const ModalLooker = ({ setOpen }) => {
    const tableRef = useRef();
    const { t } = useTranslation(['title', 'button', 'views']);

    const [data, setData] = useState({
        enrollmentsLooker
    });

    const [disabledActions, setDisabledActions] = useState([]);
    const [loadingAll, setLoadingAll] = useState(false);

    const updateLocalStorage = (newEnrollments) => {
        localStorage.setItem('lookerUpdates', JSON.stringify(newEnrollments));
    };

    const formatDateTime = () => {
        const now = new Date();
        return now.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const disableRowTemporarily = (item) => {
        setDisabledActions((prev) => [...prev, item]);
        setTimeout(() => {
            setDisabledActions((prev) => prev.filter((i) => i !== item));
        }, 10 * 60 * 1000);
    };

    const handleVisibilityClick = (rowData) => {      
        if (rowData?.link) {
          window.open(rowData.link, "_blank", "noopener,noreferrer");
        } else {
          console.warn("Nenhum link disponível para:", rowData.item);
        }
      };

    const handleIconClick = async (rowData) => {
        disableRowTemporarily(rowData.item);

        try {
            let response = null;

            if (rowData.item === 'Comentários') {
                response = await ReportLookerData.addAllComments();
            } else if (rowData.item === 'Feedback Cursos') {
                response = await ReportLookerData.addAllRatings();
            } else if (rowData.item === 'Todas matrículas') {
                response = await ReportLookerData.addAllEnrollments();
            } else if (rowData.item === 'Feedback Plataforma') {
                response = await ReportLookerData.addAllFeedback();
            } else if (rowData.item === 'Todas matrículas (Snapshot)') {
                response = await ReportLookerData.addAllEnrollmentsFull();
            } else if (rowData.item === 'Últimos 7 dias login e progresso') {
                response = await ReportLookerData.addAllLastProgress();
            } else if (rowData.item === 'Empresas e dados dos usuários')
                response = await ReportLookerData.addAllCompanies();

            const lastUpdate = response?.last_update || formatDateTime();

            const newEnrollments = data.enrollmentsLooker.map((item) =>
                item.item === rowData.item
                    ? { ...item, update: lastUpdate }
                    : item
            );

            setData((prevData) => ({
                ...prevData,
                enrollmentsLooker: newEnrollments,
            }));

            toast.success(`${rowData.item} atualizado com sucesso! 🚀🚀`);
        } catch (err) {
            if (err.response?.status === 403) {
                toast.error(`Sem permissão para atualizar ${rowData.item}`);
            } else {
                toast.error(`Erro ao atualizar ${rowData.item}`);
            }
        }
    };

    const handleUpdateAll = async () => {
        setLoadingAll(true);
        for (const item of data.enrollmentsLooker) {
            await handleIconClick(item);
        }
        setLoadingAll(false);
    };

    return (
        <Dialog open={setOpen}>
            <DialogTitle style={{ fontSize: '22px', textAlign: 'center' }}>
                Relatórios
            </DialogTitle>
            <DialogContent style={{ textAlign: 'center' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleUpdateAll}
                    disabled={loadingAll || disabledActions.length > 0}
                    style={{ marginBottom: '20px' }}
                >
                    {loadingAll ? 'Atualizando...' : 'Atualizar Todos'}
                </Button>

                <MaterialTable
                    ref={tableRef}
                    columns={[
                        { title: 'Planilha', field: 'item' },
                    ]}
                    data={data.enrollmentsLooker}
                    actions={[
                        (rowData) => ({
                            icon: 'sync',
                            tooltip: disabledActions.includes(rowData.item)
                                ? 'Aguarde para atualizar novamente'
                                : 'Executar Requisição (tempo estimado ~1min)',
                            onClick: (event, rowData) => handleIconClick(rowData),
                            disabled: disabledActions.includes(rowData.item),
                            iconProps: {
                                color: disabledActions.includes(rowData.item)
                                    ? 'disabled'
                                    : 'primary',
                            },
                        }
                        ),
                        {
                            icon: 'visibility',
                            tooltip: `Abrir planilha`,
                            onClick: (event, rowData) => {
                              handleVisibilityClick(rowData);
                            },
                            iconProps: { color: 'primary' },
                        },
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        showTitle: false,
                        search: false,
                        paging: false,
                        emptyRowsWhenPaging: false,
                        rowStyle: (rowData) => ({
                            backgroundColor:
                                rowData.tableData.id % 2 === 0 ? '#F6F9FC' : '#FFFF',
                        }),
                    }}
                />
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(false)}
                    style={{ padding: '10px 50px' }}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default ModalLooker;